const translations = {
  "en": {
    "Generating chart...": "Generating chart..."
  },
  "zh-tw": {
    "Generating chart...": "產生圖表中..."
  }
};

export default translations;
